import cls from 'classnames'
import styles from './style.module.scss'
import HCNextLink from '../HCNextLink'

interface LogoProps {
  path: string
}

const Logo = ({ path = '/' }: LogoProps) => {
  return <HCNextLink href={path} className={cls([styles.logo, 'cursor-pointer'])}></HCNextLink>
}

export default Logo
